import { ReactComponent as DataElementTopRightSquare } from '@/assets/svgs/arrow-top-right-on-square.svg';
import { ReactComponent as IconInputEdit } from '@/assets/svgs/edit-input-reference.svg';
import iconBuilding from '@/assets/svgs/icon-building.svg';
import { ReactComponent as DataElementIconInComplete } from '@/assets/svgs/icon-data-element-incomplete.svg';
import { ReactComponent as DataElementIconSuccess } from '@/assets/svgs/icon-data-element-success.svg';
import { ReactComponent as DataElementIcon } from '@/assets/svgs/icon-data-element.svg';
import { ReactComponent as IconTrashBin } from '@/assets/svgs/icon-trash-bin.svg';
import { ReactComponent as InformationCircle } from '@/assets/svgs/information-circle.svg';
import Button from '@/components/Button';
import CustomDropdown from '@/components/CustomDropdown/index.js';
import Input from '@/components/Input';
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import PaginateAttachments from '@/components/PaginateAttachments/index';
import SplitFileType from '@/components/SplitFileType/index';
import currentStatuses from "@/constants/statuses/index";
import useModal from '@/hooks/use-modal/index';
import rem from '@/utils/rem';
import classname from 'classnames';
import { useRef, useState } from "react";
import MultiClamp from 'react-multi-clamp';
import MultiLevelDropDown from '../MultiLevelMenuDropDown/index';
import { useFeature } from '@/hooks/use-feature/index.js'
import { featureConstant } from '@/constants/configuration/feature.js'
import PropTypes from 'prop-types';
import { CombinedFlows, TransactionTypes } from '@/hooks/use-ap-flow-detection/flow-types';
import RadioButton from '@/components/RadioButton';
import { shouldApplyOrLogic } from '@/hooks/use-ap-flow-detection/participant-list-builder';

export function OrganisationAvatar(organisation){
	if((Array.isArray(organisation) && organisation.length === 1) && ((organisation[0]?.iconUrl !== "") && (organisation[0]?.iconUrl !== "undefined"))){
		return organisation[0]?.iconUrl
	}

	return iconBuilding
}

/*=================================================
	Reusable Sub-Components
/================================================*/

const ParticipantDropdownSection = ({ avatarData, label, labelClassName, tooltipText, dropdownProps }) => (
	<div className='share-data-card__participants'>
		<div className='share-data-card__participants__icon'>
			<div className="avatar" style={{ backgroundImage: `url(${OrganisationAvatar(avatarData)})` }}></div>
		</div>
		<div className='share-data-card__participants__right'>
			{tooltipText ? (
				<div className={labelClassName || 'share-data-card__participants-org-name tooltip'}>
					<span className='share-data-card__participants-name'>{label}</span>
					<span className="share-data-card__icon"><InformationCircle /></span>
					<span className="tooltiptext">{tooltipText}</span>
				</div>
			) : (
				<div className='share-data-card__participants-name'>{label}</div>
			)}
			<CustomDropdown {...dropdownProps} />
		</div>
	</div>
);

ParticipantDropdownSection.propTypes = {
	avatarData: PropTypes.array,
	label: PropTypes.string.isRequired,
	labelClassName: PropTypes.string,
	tooltipText: PropTypes.string,
	dropdownProps: PropTypes.object.isRequired
};

const OrLogicParticipantsSection = ({
	recipientId,
	keyPrefix,
	onBehalfOf,
	onBehalfOfList,
	principals,
	principalsList,
	handleOnBehalfOfChange,
	handlePrincipalsChange,
	testIdSuffix
}) => (
	<>
		<ParticipantDropdownSection
			avatarData={onBehalfOf}
			label="Provide On Behalf Of"
			dropdownProps={{
				key: `onbehalfof-${keyPrefix}-${recipientId}`,
				items: onBehalfOfList,
				value: onBehalfOf,
				keyText: "Contributor",
				type: "radio",
				disable: principals.length > 0,
				onChangeFunc: handleOnBehalfOfChange,
				dataTestId: `onBehalfOf-dropdown-${testIdSuffix}`,
				showEnhancedDisabled: true,
			}}
		/>
		<div className="share-data-card__or-divider">
			<span className="share-data-card__or-divider__line"></span>
			<span className="share-data-card__or-divider__text">or</span>
			<span className="share-data-card__or-divider__line"></span>
		</div>
		<ParticipantDropdownSection
			avatarData={principals}
			label="Select My Principals"
			dropdownProps={{
				key: `principals-${keyPrefix}-${recipientId}`,
				items: principalsList,
				value: principals,
				keyText: "My Principals",
				type: "checkbox",
				allSelected: false,
				togglecheck: false,
				disable: onBehalfOf.length > 0,
				onChangeFunc: handlePrincipalsChange,
				dataTestId: `my-principals-dropdown-${testIdSuffix}`,
				searchPlaceholder: "Search Organisation, UEN...",
				listHeaderText: "Principal",
				searchFields: ['name', 'uen'],
				renderItemLabel: (item) => (
					<span className="principal-item-label">
						<span className="principal-item-label__name">{item.name}</span>
						<span className="principal-item-label__uen">UEN: {item.uen}</span>
					</span>
				),
				showEnhancedWidth: true,
				showEnhancedDisabled: true,
			}}
		/>
	</>
);

OrLogicParticipantsSection.propTypes = {
	recipientId: PropTypes.string,
	keyPrefix: PropTypes.string.isRequired,
	onBehalfOf: PropTypes.array.isRequired,
	onBehalfOfList: PropTypes.array.isRequired,
	principals: PropTypes.array.isRequired,
	principalsList: PropTypes.array.isRequired,
	handleOnBehalfOfChange: PropTypes.func.isRequired,
	handlePrincipalsChange: PropTypes.func.isRequired,
	testIdSuffix: PropTypes.string.isRequired
};

const DataElementCard = ({
		status = currentStatuses.not_started,
		recipient,
		referenceId,
		dataElement,
		storeFor,
		payload,
		action,
		onBehalfOf,
		onBehalfOfList,
		requiredAttachments,
		attachments,
		behalfPanel,
		participantsList,
		storeForList,
		combineAttachments,
		getRootPropsPayload,
		getInputPropsPayload,
		getRootPropsAttachment,
		getInputPropsAttachment,
		containAttachments,
		matchingAttachments,
		nonMatchingAttachments,
		handleRemoveSingleFile,
		handleDownloadSingleFile,
		onFillEformBtnClick,
		handleReferenceID,
		handleRemoveFile,
		handleRecipientChange,
		handleStoreForChange,
		handleOnBehalfOfChange,
		isPackage = false,
		packageDropdownMenu,
		principals,
		principalsList,
		handlePrincipalsChange,
		transactionType,
		availableTransactionTypes,
		onTransactionTypeChange,
		onReset,
		versionSelector,
}) => {

	const isAgentPrincipalUiEnabled = useFeature(featureConstant.AGENT_PRINCIPAL_UI);
	
	const [attachmentModal, setAttachmentModal] = useState(false)
	const [activeReferenceID, setActiveReferenceID] = useState(false)

	/*=================================================
		Reference ID
	/================================================*/
	const referenceIdRef = useRef(null)

	/*=================================================
		Custom Classnames
	/================================================*/
	const structuredDataClassName = classname({
		"share-data-card__section": true,
		"share-data-card__section--disabled": recipient?.length === 0 || (isPackage && behalfPanel && onBehalfOf?.length === 0)
	})

	const attachmentDataClassName = classname({
		"share-data-card__section": true,
		"share-data-card__section--disabled": (payload?.length === 0 || containAttachments === false) && action?.type !== "IMPORTED"
	})

	/*=================================================
		Attachment Dropzone
	/================================================*/

	function renderUplaodAttachment() {
		return (
			<div className="share-data-card__upload-attachment" {...getRootPropsAttachment()}>
				<input
					{...getInputPropsAttachment()}
					data-testid="attachment-dropzone"
				/>
				Upload Attachment
			</div>
		);
	}

	/*=================================================
		Remove File
	/================================================*/
	const { visible: verifyModal, show: showVerifyModal, hide: hideVerifyModal } = useModal()
	const [file, setFile]= useState()

	const handleVerifyRemove = () => {
		handleRemoveSingleFile(file)
		setFile()
	}

	const renderStandalonePrincipalsSection = (keyPrefix, testId) => (
		<ParticipantDropdownSection
			avatarData={principals}
			label="Select My Principals"
			dropdownProps={{
				key: `${keyPrefix}-${recipient[0]?.id}`,
				items: principalsList,
				value: principals,
				keyText: "My Principals",
				type: "checkbox",
				allSelected: false,
				togglecheck: false,
				onChangeFunc: handlePrincipalsChange,
				dataTestId: testId,
				searchPlaceholder: "Search Organisation, UEN...",
				listHeaderText: "Principal",
				searchFields: ['name', 'uen'],
				renderItemLabel: (item) => (
					<span className="principal-item-label">
						<span className="principal-item-label__name">{item.name}</span>
						<span className="principal-item-label__uen">UEN: {item.uen}</span>
					</span>
				),
				showEnhancedWidth: true,
				showEnhancedDisabled: true,
			}}
		/>
	);

	return (
		<>
			{
				!attachmentModal &&
				<div className="share-data-card">
					{!isPackage && (
						<div className='share-data-card__header'>
							<div className="share-data-card__header__left share-data-card__header__left--icon">
								{status === currentStatuses.not_started && (<DataElementIcon />)}
								{status === currentStatuses.in_progress && (<DataElementIconInComplete />)}
								{status === currentStatuses.complete && (<DataElementIconSuccess />)}
							</div>

							<div className='share-data-card__header__right'>
								<div className='share-data-card__header__top share-data-card__header__top--element'><MultiClamp clamp={2}>{dataElement?.name}</MultiClamp></div>
								{!activeReferenceID && (
									<div className='share-data-card__header__bottom'>
										<div className='share-data-card__header__reference-id'><MultiClamp clamp={1}>{referenceId ? referenceId : 'Reference ID (Optional)'}</MultiClamp></div>
										<IconInputEdit data-testid="edit-reference-id" onClick={()=> setActiveReferenceID(true)}/>
									</div>
								)}
								{activeReferenceID && (
									<div className='share-data-card__header__bottom'>
										<Input
											className='share-data-card__header__reference-input'
											placeholder='Reference ID (Optional)'
											defaultValue={referenceId}
											autoFocus
											register={referenceIdRef}
											maxlength={100}
										/>
									<div
										onClick={() => {
											setActiveReferenceID(false)
											handleReferenceID(referenceIdRef.current.value)
										}}
										className="share-data-card__reference-save">Save</div>
									</div>
								)}
							</div>
						</div>
					)}

					{isPackage && (
						<div className="share-data-card__header--package">
							<div className="share-data-card__header__left">
								{status === currentStatuses.not_started && (<DataElementIcon />)}
								{status === currentStatuses.in_progress && (<DataElementIconInComplete />)}
								{status === currentStatuses.complete && (<DataElementIconSuccess />)}
							</div>
							<div className='share-data-card__header__right--package'>
								<div className='share-data-card__header__top share-data-card__header__top--element'><MultiClamp clamp={2}>{dataElement?.name}</MultiClamp></div>
							</div>
							<div className='share-data-card__header__menu'>
								{dataElement?.isNew && <span className="package-received-data-card__new-tag" data-testid="new-tag">New</span>}
								<MultiLevelDropDown
									menuList={packageDropdownMenu}
								/>
							</div>
						</div>
					)}
					{isAgentPrincipalUiEnabled && (
						<div className='share-data-card__transaction-type'>
							<div className='share-data-card__transaction-type__heading'>
								Transaction Type
								<span className="share-data-card__icon tooltip">
									<InformationCircle />
									<span className="tooltiptext">
										<strong>Push:</strong> Contributing your data to a selected recipient.
										<br />
										<strong>Push to Agent:</strong> Contributing your data to the selected recipient&apos;s Principal(s).
									</span>
								</span>
							</div>
							<div className='share-data-card__transaction-type__radios'>
								<RadioButton
									name="Push/ Store"
									check={transactionType === TransactionTypes.PUSH_STORE}
									disabled={!availableTransactionTypes?.hasPushStore}
									submit={() => onTransactionTypeChange(TransactionTypes.PUSH_STORE)}
									data-testid="transaction-type-push-store"
								/>
								
								<RadioButton
									name="Push to Agent"
									check={transactionType === TransactionTypes.PUSH_TO_AGENT}
									disabled={!availableTransactionTypes?.hasPushToAgent}
									submit={() => onTransactionTypeChange(TransactionTypes.PUSH_TO_AGENT)}
									data-testid="transaction-type-push-agent"
								/>
							</div>
						</div>
					)}
					<div className='share-data-card__section'>
						<div className='share-data-card__heading share-data-card__content--margin-bottom'>Participants</div>
						<div className='share-data-card__participants'>
							<div className='share-data-card__participants__icon'>
								<div className="avatar" style={{ backgroundImage: `url(${OrganisationAvatar(recipient)})` }}></div>
							</div>
							<div className='share-data-card__participants__right'>
								<div className='share-data-card__participants-name'>Recipient</div>
								<CustomDropdown
									items={participantsList}
									value={recipient}
									keyText="Recipient"
									type="radio"
									disable={isPackage && participantsList.length <= 1}
									onChangeFunc={(option) => {
										handleRecipientChange(option)
									}}
									dataTestId="recipient-dropdown"
									isPackage={isPackage}
								/>
								{versionSelector}
							</div>
						</div>
						{isAgentPrincipalUiEnabled && recipient?.[0]?.isMerged && (
							<>
								{/* POB_POBOP with OR logic */}
								{recipient[0].mergedType === CombinedFlows.POB_POBOP && transactionType === TransactionTypes.PUSH_STORE && shouldApplyOrLogic(recipient, transactionType) && (
									<OrLogicParticipantsSection
										recipientId={recipient[0]?.id}
										keyPrefix="or"
										onBehalfOf={onBehalfOf}
										onBehalfOfList={onBehalfOfList}
										principals={principals}
										principalsList={principalsList}
										handleOnBehalfOfChange={handleOnBehalfOfChange}
										handlePrincipalsChange={handlePrincipalsChange}
										testIdSuffix="pob-pobop-or"
									/>
								)}
								
								{/* CONTRIBUTOR_POBOP: No On Behalf Of, show My Principals */}
								{recipient[0].mergedType === CombinedFlows.CONTRIBUTOR_POBOP && principalsList.length > 0 && 
									renderStandalonePrincipalsSection('principals-contributor-pobop', 'my-principals-dropdown-contributor-pobop')
								}

								{/* CONTRIBUTOR_POB_POBOP with OR logic */}
								{recipient[0].mergedType === CombinedFlows.CONTRIBUTOR_POB_POBOP && transactionType === TransactionTypes.PUSH_STORE && shouldApplyOrLogic(recipient, transactionType) && (
									<OrLogicParticipantsSection
										recipientId={recipient[0]?.id}
										keyPrefix="full-or"
										onBehalfOf={onBehalfOf}
										onBehalfOfList={onBehalfOfList}
										principals={principals}
										principalsList={principalsList}
										handleOnBehalfOfChange={handleOnBehalfOfChange}
										handlePrincipalsChange={handlePrincipalsChange}
										testIdSuffix="contributor-pob-pobop-or"
									/>
								)}
							</>
						)}
						{recipient && recipient[0]?.id === 'MY_PITSTOP' && (
							<div className='share-data-card__participants'>
								<div className='share-data-card__participants__icon'>
									<div className="avatar" style={{ backgroundImage: `url(${OrganisationAvatar(storeFor)})` }}></div>
								</div>
								<div className='share-data-card__participants__right'>
									<div className='share-data-card__participants-org-name tooltip'>
										<span className='share-data-card__participants-name'>Selected Organisations</span>
										<span className="share-data-card__icon"><InformationCircle /></span>
										<span className="tooltiptext">Only Selected Organisations are allowed to consume this data from you</span>
									</div>
									<CustomDropdown
										items={storeForList}
										value={storeFor}
										keyText="Organisations"
										type="checkbox"
										allSelected={false}
										togglecheck={true}
										onChangeFunc={(option) => {
											handleStoreForChange(option)
										}}
										dataTestId="storeFor-dropdown"
									/>
								</div>
							</div>
						)}
						{behalfPanel && (isAgentPrincipalUiEnabled ? !recipient[0]?.isMerged : true) && (
							<div className='share-data-card__participants'>
								<div className='share-data-card__participants__icon'>
										<div className="avatar" style={{ backgroundImage: `url(${OrganisationAvatar(onBehalfOf)})` }}></div>
									</div>
								<div className='share-data-card__participants__right'>
									<div className='share-data-card__participants-name'>Provide On Behalf Of</div>
										<CustomDropdown
											items={onBehalfOfList}
											value={onBehalfOf}
											disable={onBehalfOfList.length === 1}
											keyText="Contributor"
											type="radio"
											onChangeFunc={(option) => {
												handleOnBehalfOfChange(option)
											}}
											dataTestId="onBehalfOf-dropdown"
											isPackage={isPackage}
										/>
								</div>
							</div>
						)}
						{isAgentPrincipalUiEnabled && recipient?.[0]?.isAgent && !recipient[0]?.isMerged && (
							<ParticipantDropdownSection
								avatarData={principals}
								label="Select Recipient's Principals"
								dropdownProps={{
									key: `agent-principals-${recipient[0]?.id}`,
									items: principalsList,
									disable: onBehalfOfList?.length > 0 && onBehalfOf?.length === 0,
									value: principals,
									keyText: "Recipient's Principals",
									type: "checkbox",
									allSelected: false,
									togglecheck: false,
									onChangeFunc: handlePrincipalsChange,
									dataTestId: "principals-dropdown",
									searchPlaceholder: "Search Organisation, UEN...",
									listHeaderText: "Principal",
									searchFields: ['name', 'uen'],
									renderItemLabel: (item) => (
										<span className="principal-item-label">
											<span className="principal-item-label__name">{item.name}</span>
											<span className="principal-item-label__uen">UEN: {item.uen}</span>
										</span>
									),
									showEnhancedWidth: true,
									showEnhancedDisabled: true
								}}
							/>
						)}
						{isAgentPrincipalUiEnabled && recipient?.[0]?.isPOBOP && !recipient[0]?.isMerged && principalsList.length > 0 && 
							renderStandalonePrincipalsSection('pobop-principals', 'my-principals-dropdown')
						}
					</div>
					<div className={structuredDataClassName}>
						<div className='share-data-card__content--margin-bottom tooltip'>
							<span className="share-data-card__heading">Structured Data</span>
							<span className="share-data-card__icon"><InformationCircle /></span>
							<span className="tooltiptext">{isPackage ? "Fill E-form / Upload .CSV file" : "Fill E-form / Upload .CSV or .JSON file"}</span>
						</div>
						{payload?.length === 0 &&(
							<>
								<div className="share-data-card__structured-section">
									<div className="share-data-card__structured-section__sub-heading"
										data-testid="fill-eform-test"
										onClick={()=>{
											onFillEformBtnClick()
										}}
									>Fill E-Form</div>
									<div className='share-data-card__structured-section__heading-or'>or</div>
									<div className="share-data-card__structured-section__sub-heading"
										{...getRootPropsPayload()}
									>
										<input
											{...getInputPropsPayload()}
											data-testid="payload-dropzone"
										/>
										Upload File
									</div>
								</div>
							</>
						)}
						{payload?.length > 0 && (
							<div className='share-data-card__structured-section_content'>
								{action.type === "EFORM" && (
									<span>
										Filled via E-form
									</span>
								)}
								{action.type === "UPLOAD" && (
									<SplitFileType text={action?.value} maxWidth={216}/>
								)}
								{action.type === "IMPORTED" && (
									<span>
										Imported Data
									</span>
								)}
								<span className='share-data-card__content__icons' data-testid="filled-eform-info">
									{action.type === "EFORM" && <DataElementTopRightSquare
										data-testid="fill-data-element-button"
										onClick={()=> {
											onFillEformBtnClick()
										}}
									/>}
									{action.type !== "IMPORTED" && (
										<IconTrashBin
											data-testid="filled-eform-delete"
											onClick={()=> {
												handleRemoveFile()
											}}
										/>
									)}
								</span>
							</div>
						)}
					</div>
					<div className={attachmentDataClassName}>
						<div className='share-data-card__content--margin-bottom tooltip'>
							<span className="share-data-card__heading">Attachments</span>
							<span className="share-data-card__icon"><InformationCircle /></span>
							<span className="tooltiptext">{isPackage ? "Upload .PDF attachment" : "Upload .PDF or .DOC or .DOCX. OR .TT or .XLSX or .XML or .XLS or .JPG or .JPEG attachment"}</span>
						</div>

						{!isPackage && (matchingAttachments.length > 0 || nonMatchingAttachments.length > 0 || requiredAttachments?.length > 0 ) && (
							<div className="share-data-card__structured-section_content">
								<span>
									{requiredAttachments.length > 0 && (
										<>
											Required {matchingAttachments.length}/{requiredAttachments.length}
										</>
									)}
									{requiredAttachments.length > 0 && nonMatchingAttachments.length > 0 && (
										<>, </>
									)}
									{nonMatchingAttachments.length > 0 && (
										<>Optional {nonMatchingAttachments.length}</>
									)}
								</span>
								<span className='share-data-card__content__icons' data-testid='attachment-delete'>
									<DataElementTopRightSquare
										data-testid="data-element-card-view"
										onClick={()=> {
											setAttachmentModal(true)
										}}
									/>
								</span>
							</div>
						)}

						{(isPackage && combineAttachments.length > 0) && (
							<div className="share-data-card__structured-section_content">
								<span>
									<>Uploaded Attachment &#40;{combineAttachments.length}&#41;</>
								</span>
								<span className='share-data-card__content__icons'>
									<DataElementTopRightSquare
										data-testid="data-element-card-view"
										onClick={()=> {
											setAttachmentModal(true)
										}}
									/>
								</span>
							</div>
						)}

						{(isPackage && combineAttachments.length === 0 && action.type === "IMPORTED") && (
							<div className="share-data-card__structured-section_content">
								<span>
									No attachment
								</span>

							</div>
						)}

						{containAttachments && action.type !== "IMPORTED" && (
							<>{renderUplaodAttachment()}</>
						)}
					</div>
					{isAgentPrincipalUiEnabled && (
						<div className="share-data-card__reset-section">
							<Button 
								text="Reset" 
								noborder
								nobackground
								sizing="Medium"
								submit={onReset}
								data-testid="reset-button"
							/>
						</div>
					)}
				</div>
			}
			{
				attachmentModal &&
				<div className="share-data-card share-data-card--flex">
					<div className="share-data-card__upload__header">
						<MultiClamp clamp={1} className="share-data-card__upload__header__title">{dataElement?.name}</MultiClamp>
					</div>
					<div className="share-data-card__upload__sub-header">
						Attachments({matchingAttachments.length + nonMatchingAttachments.length})
					</div>
					<div className="share-data-card__upload__content">
						<PaginateAttachments
							combineAttachments={combineAttachments}
							attachments={attachments}
							requiredAttachments={requiredAttachments}
							handleDownloadSingleFile={handleDownloadSingleFile}
							showVerifyModal={showVerifyModal}
							setFile={setFile}
							showDelete={action.type === "IMPORTED" ? false : true}
						/>
					</div>
					{action.type !== "IMPORTED" &&(
						<div className="share-data-card__upload__upload">
							{renderUplaodAttachment()}
						</div>
					)}
					<div className="share-data-card__upload__footer">
						<span className="share-data-card__upload-attachment" onClick={()=>{setAttachmentModal(false)}}>
							Back
						</span>
					</div>
				</div>
			}

			<Modal visible={verifyModal} variant='medium'  close={hideVerifyModal}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon--error'}>
											<IconTrashBin />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Delete Data
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className='share__card-configure-text'>Are you sure want to delete the uploaded Attachment(s)?</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button ghost text="Cancel"
								submit={() => {
									hideVerifyModal()
								}}
							/>
							<span style={{ width: rem(10), display: 'inline-block' }}></span>
							<Button ghost
								text="Confirm"
								warning
								submit={() => {
									handleVerifyRemove()
									hideVerifyModal()
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>
		</>
	)
}


export default DataElementCard;

DataElementCard.propTypes = {
	versionSelector: PropTypes.node,
	status: PropTypes.string,
	recipient: PropTypes.array,
	referenceId: PropTypes.string,
	dataElement: PropTypes.object,
	storeFor: PropTypes.array,
	payload: PropTypes.array,
	action: PropTypes.object,
	onBehalfOf: PropTypes.array,
	onBehalfOfList: PropTypes.array,
	requiredAttachments: PropTypes.array,
	attachments: PropTypes.array,
	behalfPanel: PropTypes.bool,
	participantsList: PropTypes.array,
	storeForList: PropTypes.array,
	combineAttachments: PropTypes.array,
	getRootPropsPayload: PropTypes.func,
	getInputPropsPayload: PropTypes.func,
	getRootPropsAttachment: PropTypes.func,
	getInputPropsAttachment: PropTypes.func,
	containAttachments: PropTypes.bool,
	matchingAttachments: PropTypes.array,
	nonMatchingAttachments: PropTypes.array,
	handleRemoveSingleFile: PropTypes.func,
	handleDownloadSingleFile: PropTypes.func,
	onFillEformBtnClick: PropTypes.func,
	handleReferenceID: PropTypes.func,
	handleRemoveFile: PropTypes.func,
	handleRecipientChange: PropTypes.func,
	handleStoreForChange: PropTypes.func,
	handleOnBehalfOfChange: PropTypes.func,
	isPackage: PropTypes.bool,
	packageDropdownMenu: PropTypes.array,
	principals: PropTypes.array,
	principalsList: PropTypes.array,
	handlePrincipalsChange: PropTypes.func,
	transactionType: PropTypes.string,
	availableTransactionTypes: PropTypes.object,
	onTransactionTypeChange: PropTypes.func,
	onReset: PropTypes.func
};
